/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

class LuiIconManager {
  constructor() {
    this._loaders = []
  }

  addLoader(loader) {
    this._loaders.push(loader)
  }

  getIcon(iconName) {
    return this._loadResource(this._loaders, iconName)
  }

  _loadResource(loaders, iconName, index = 0) {
    return new Promise((resolve, reject) => {
      loaders[index].getIcon(iconName)
        .then(resolve)
        .catch((error) => {
          if (index < loaders.length) {
            this._loadResource(loaders, iconName, index + 1)
              .then(resolve)
          } else {
            reject(error)
          }
        })
    })
  }
}

export default new LuiIconManager()



//////////////////
// WEBPACK FOOTER
// ./packages/lui-icon/lui-icon-manager.js
// module id = 138
// module chunks = 0 1 12